// import React from "react";
// import { IconButton } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { toggleTheme } from "../../store/slices/themeSlice";
// import { RootState } from "../../store";
// import LightModeIcon from "@mui/icons-material/LightMode";
// import DarkModeIcon from "@mui/icons-material/DarkMode";

// const ThemeToggle: React.FC = () => {
//   const mode = useSelector((state: RootState) => state.themeState.mode);
//   const dispatch = useDispatch();

//   return (
//     <IconButton onClick={() => dispatch(toggleTheme())} color="inherit">
//       {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
//     </IconButton>
//   );
// };

// export default ThemeToggle;

import React from "react";
import { Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../store/slices/themeSlice";
import { RootState } from "../../store";

const ThemeToggle: React.FC = () => {
  const mode = useSelector((state: RootState) => state.themeState.mode);
  const dispatch = useDispatch();

  return (
    <Switch
      checked={mode === "dark"}
      onChange={() => dispatch(toggleTheme())}
      color="default"
    />
  );
};

export default ThemeToggle;
